import { Box } from "@mui/material";
import styled from "styled-components";

export const ModalBox = styled(Box)`
  font-family: "Inter", sans-serif;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 30%;
  height: auto;
  background-color: #ffffff;
  border-radius: 20px;
  box-shadow: 24px;

  @media (max-width: 1024px) {
    width: 60%;
  }

  @media (max-width: 767px) {
    width: 80%;
  }
`;

export const HeaderModal = styled.h1`
  font-size: 24px;
  font-weight: 600;
  background-color: #13314d;
  color: #ffffff;
  margin: 0;
  padding: 15px 0;
  text-align: center;
  border-radius: 20px 20px 0 0;
`;

export const BodyMessage = styled.p`
  font-size: 18px;
  font-weight: 400;
  padding: 20px 20px 0 20px;
  margin: 0;
  text-align: center;
`;

export const ButtonContainer = styled.div`
  margin: 20px;
`;
